import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

import { GridBox } from '@eltoro-ui/components';

import EllipsisTextWithTooltip from 'Components/EllipsisTextWithTooltip';
import { SpinnerLoader } from 'Components/SpinnerLoader';

import './LocationLabel.scss';

export const truncate = (str: string, len = 20) => {
  return str.length >= len ? str.substring(0, len) : str;
};
export const LocationLabel: React.FC<{
  location: any;
  onRemove: (id: string) => void;
  loading?: boolean;
}> = ({ location, onRemove, loading }) => {
  return (
    <div className="LocationLabel">
      <GridBox
        gridTemplateColumns="min-content auto min-content"
        gap="0.2rem"
        padding="0.25rem"
        alignItems="center"
      >
        <div className="LocationLabel__icon-circle">
          <FontAwesomeIcon icon={faSearch} />
        </div>

        <EllipsisTextWithTooltip text={location.display_value} className="LocationLabel__label" />

        <div className="LocationLabel__icon-circle">
          {loading ? (
            <SpinnerLoader
              style={{
                position: 'unset',
                width: '1.5rem',
                height: '1.5rem',
                borderWidth: '0.23em',
              }}
            />
          ) : (
            <button
              aria-label={`Click to remove location: ${location.value}`}
              className="LocationLabel__delete-button"
              type="button"
              onClick={() => location && onRemove(location.value)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
        </div>
      </GridBox>
    </div>
  );
};
